import { render } from "./pen.vue?vue&type=template&id=201fff2e"
const script = {}
script.render = render

export default script